import React, { useEffect, useState } from 'react';
import styles from './Organizations.module.css';
import useApi from '../../../hooks/useApi.hook';
import Spinner from '../../Spinner/Spinner';
import PickTemplates from '../components/PickTemplates/PickTemplates';
import OrganizationManage from './OrganizationManage/OrganizationManage';
import {apiErrorMessage} from '../../../helpers/apiError';
import {notifyDownloadQueued} from '../../../helpers/downloadsEvents';
import {getRosterBindsUrl} from '../../../helpers/constants';

export function Organizations() {
	const api = useApi();
	const [selectedTemplate, setSelectedTemplate] = useState('');
	const [placeholders, setPlaceholders] = useState([]);
	const [error, setError] = useState(undefined);
	const [loading, setLoading] = useState(false);
	const [rosterEmpty, setRosterEmpty] = useState(false);

	useEffect(() => {
		setRosterEmpty(false);
		if (!selectedTemplate) return;
		let cancelled = false;
		api.get(getRosterBindsUrl)
			.then(({ data }) => {
				const codes = data.rosters
					.filter(r => r.template === selectedTemplate)
					.map(r => r.code);
				const isEmpty = codes.length > 0
					&& !data.binds.some(b => codes.includes(b.roster_code));
				if (!cancelled) setRosterEmpty(isEmpty);
			})
			.catch(() => {});
		return () => { cancelled = true; };
	}, [selectedTemplate]);

	const handleGenerate = async () => {
		const plh = placeholders
			.filter((p) => p.key?.trim() && p.value?.trim())
			.map((p) => ({ key: p.key, value: p.value }));

		if (!selectedTemplate) {
			console.log('No template selected, aborting.');
			return;
		}

		setError(undefined);
		setLoading(true);
		try {
			const response = await api.post('/documents/organization_generate', {
				template: selectedTemplate,
				placeholders: plh
			});

			notifyDownloadQueued(response.data);
		} catch (e) {
			setError(apiErrorMessage(e));
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={styles.container}>
			{error && (
				<div className={styles.error} onClick={() => setError(undefined)}>
					{error} <span className={styles.errorClose}>✖</span>
				</div>
			)}
			{rosterEmpty && (
				<div className={styles.warning}>
					В перечень не отмечено ни одной профессии — отметьте их в «Привязки → Перечни»
				</div>
			)}
			<div className={styles.topRow}>
				<PickTemplates
					groupName="organization"
					selectedTemplate={selectedTemplate}
					setSelectedTemplate={setSelectedTemplate}
					placeholders={placeholders}
					setPlaceholders={setPlaceholders}
				/>
				<OrganizationManage
					onGenerate={handleGenerate}
					loading={loading}
					selectedTemplate={selectedTemplate}
				/>
			</div>

			{loading && (
				<div className={styles.spinnerOverlay}>
					<Spinner showSeconds={true} />
				</div>
			)}
		</div>
	);
}